import {Item} from '../lookups/item';
import {Entity} from '../base/entity';

export class ContractItem extends Entity {

  public static readonly TABLENAME = 'contract_item';

  public static readonly CONTRACT_ID = 'contract_id';
  public static readonly ITEM_ID = 'item_id';
  public static readonly QUANTITY = 'quantity';
  public static readonly PRICE_PER_UNIT = 'price_per_unit';
  public static readonly QUANTITY_OFF = 'quantity_off';
  public static readonly TOTAL_OFF = 'total_off';
  public static readonly CREATED_AT = 'created_at';
  public static readonly UPDATED_AT = 'updated_at';
  public static readonly DELETED_AT = 'deleted_at';
  public static readonly DATE_FROM = 'date_from';
  public static readonly DATE_TO = 'date_to';
  public static readonly JEDINICA_CENA_SA_PDVOM = 'jedinicaCenaSaPdvom'

  item: Item;

  contractId: string;
  itemId: string;
  quantity: number;
  pricePerUnit: number;
  quantityOff: number;
  totalOff: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  dateFrom: Date;
  dateTo: Date;
  jedinicaCenaSaPdvom: number;
}
